import { EFacilityType, NonEmptyArray } from '../../../../../../../packages/JsonQuery';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectSuburbanFacilitiesFilter } from 'shared/selectors/advancedFilters';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';

export const SuburbanFacilitiesContainer: FC = () => {
  const { label, value, options } = useSelector(selectSuburbanFacilitiesFilter);

  const onChange = useFilterChangeCallback();

  const handleSuburbanFacilitiesChange = useCallback(
    (newValue: NonEmptyArray<EFacilityType> | null) => {
      onChange({ action: 'setSuburbanFacilityTypes', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter options={options} value={value} onFilterChange={handleSuburbanFacilitiesChange} />
    </AdvancedFilterRow>
  );
};
